import React, { Component } from "react";
import GitHubCalendar from "react-github-calendar";
import ReactTooltip from "react-tooltip";
import { Avatar, Card, Dropdown, Icon, List, Menu, Tooltip } from "antd";

class GithubProfile extends Component {
  constructor(props) {
    super(props);
    this.state = { data: null };
  }

  componentDidMount() {
    //     fetch('http://localhost:3000/hackerrank/api/problem_submissions/v1.0/prashanth726')
    //     .then(response => {
    //         
    //         return response.json()
    //     })
    //     .then(data => {
    //         this.setState({ data })
    // });

    fetch(
      `https://api.github.com/users/${this.props.userName}/repos?type=owner&sort=created`
    )
      .then(response => response.json())
      .then(data => {
        
        if (!data.message) {
          data = data.filter(i => i.fork == false);
          this.setState({ data });
        }
      });
  }

  render() {
    const { data } = this.state;

    return (
      <div>
        <GitHubCalendar username={this.props.userName}>
          <ReactTooltip delayShow={50} html />
        </GitHubCalendar>
        <h3 style={{ marginTop: 40 }}>Repositories</h3>
        {data && data.length > 0 ? (
          <List
            rowKey="id"
            className="stylesApplications.filterCardList"
            pagination={{
              pageSize: 6,
              position: "bottom"
            }}
            total="{1}"
            grid={{
              gutter: 24,
              xxl: 3,
              xl: 3,
              lg: 3,
              md: 3,
              sm: 3,
              xs: 1
            }}
            dataSource={data}
            renderItem={item => (
              <List.Item key={item.name}>
                <Card
                  hoverable
                  bodyStyle={{
                    paddingBottom: 20
                  }}
                  actions={[
                    <Tooltip
                      key="download"
                      title={`${item.stargazers_count} Stars`}
                    >
                      <Icon type="star" /> {item.stargazers_count}
                    </Tooltip>,
                    <Tooltip title={`${item.forks} Forks`} key="edit">
                      <Icon type="fork" /> {item.forks}
                    </Tooltip>
                  ]}
                >
                  <Tooltip
                    title={
                      item.description ? item.description : "No Description"
                    }
                  >
                    <Card.Meta
                      avatar={
                        <Avatar size="small" src={item.owner.avatar_url} />
                      }
                      title={
                        <a target="_blank" href={item.html_url}>
                          {item.name}
                        </a>
                      }
                      description={
                        item.description
                          ? item.description.substring(0, 20)
                          : "No Description"
                      }
                    />
                  </Tooltip>
                  <div
                    style={{ marginTop: 30 }}
                    className="stylesApplications.cardItemContent"
                  >
                    <div>
                      {" "}
                      Created on :{" "}
                      {item.created_at.replace(
                        /(\d+)-(\d+)-(\d+)T(\d+):(\d+):(\d+)Z/,
                        "$3/$2/$1 $4:$5:$6"
                      )}
                    </div>
                    <div>
                      {" "}
                      Updated on :{" "}
                      {item.updated_at.replace(
                        /(\d+)-(\d+)-(\d+)T(\d+):(\d+):(\d+)Z/,
                        "$3/$2/$1 $4:$5:$6"
                      )}
                    </div>
                  </div>
                </Card>
              </List.Item>
            )}
          />
        ) : (
          "No Repositories found"
        )}

        {/* {data &&
            data.map((i)=> i.name )
           } */}
      </div>
    );
  }
}

export default GithubProfile;
